const Fallback = () => {
  return <div>Something went wrong. Please try again later.</div>;
};

export default Fallback;
